import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";
import { useField } from "formik";
import { getDateRange } from "../../helpers/date-time-helper";
import { formatMessage } from "../../translations/format-message";
import { MONTH_YEAR_FORMAT } from "../../constants/constants";
import { observer } from "mobx-react";
import { useStore } from "../../contexts/store-provider";
import "dayjs/locale/en";
import "dayjs/locale/ja";

const FormikMonthYearFieldMUI = (props: any) => {
  const {preferencesStore} = useStore();
  const {
    disabled,
    min,
    max,
    label,
    disableFuture,
    disablePastDate,
    publishDateRange,
    isScheduleCheck = false,
    isWeekdayScheduleCheck = false,
    getClosedDays,
  } = props;
  const [field, meta, helpers] = useField(props);
  const { touched, error } = meta;

  const shouldDisableDate = (date: Dayjs) => {
    const day = date.day();
    const dateStr = date.format(MONTH_YEAR_FORMAT);
    const publishedDates = getDateRange(
      publishDateRange.startDate,
      publishDateRange.endDate
    );
    return (
      (getClosedDays &&
        getClosedDays.map((day: any) => day.WeekDays).includes(day)) ||
      (publishedDates && publishedDates.includes(dateStr))
    );
  };

  const shouldDisableClosedDates = (date: Dayjs) => {
    const day = date.day();
    return (
      getClosedDays &&
      getClosedDays.map((day: any) => day.WeekDays).includes(day)
    );
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    event.preventDefault();
  };
  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={preferencesStore.getLanguage === "en" ? "en" : "ja"}
      >
        <Stack spacing={3}>
          <DesktopDatePicker
            label={label}
            views={["year", "month"]}
            inputFormat="YYYY/MM"
            value={field.value ? dayjs(field.value) : null}
            className="datepicker-control"
            onChange={(newValue: any) => {
              helpers.setValue(
                newValue ? dayjs(newValue).format(MONTH_YEAR_FORMAT) : ""
              );
            }}
            disableFuture={disableFuture}
            disablePast={disablePastDate}
            disabled={disabled}
            minDate={min ? dayjs(min) : undefined}
            maxDate={max ? dayjs(max) : undefined}
            renderInput={(params: any) => (
              <TextField {...params} onKeyDown={onKeyDown} />
            )}
            shouldDisableDate={
              isScheduleCheck
                ? shouldDisableDate
                : isWeekdayScheduleCheck
                ? shouldDisableClosedDates
                : undefined
            }
            PopperProps={{
              modifiers: [
                {
                  name: "flip",
                  enabled: true,
                  options: {
                    fallbackPlacements: ["top-start", "bottom-start"],
                  },
                },
                {
                  name: "preventOverflow",
                  enabled: true,
                  options: {
                    altAxis: true,
                    tether: true,
                  },
                },
              ],
            }}
          />
        </Stack>
      </LocalizationProvider>
      {touched && error && (
        <span data-testid="testError" className="text-danger errorMessage">
          {formatMessage(error)}
        </span>
      )}
    </>
  );
}

export default observer(FormikMonthYearFieldMUI);
